import { FaBlender, FaBookOpen, FaBroom, FaCoffee, FaDesktop, FaFilm, FaHandsWash, FaHome, FaInfoCircle, FaNewspaper, FaSkiing, FaSmokingBan, FaSpa, FaSwimmer, FaTv, FaUserTie, FaWifi } from "react-icons/fa";
import { FaBellConcierge, FaChild, FaElevator, FaFire, FaHotTubPerson, FaKitchenSet, FaMountain, FaMugHot, FaPhone, FaSquareParking } from "react-icons/fa6";
import { PiArrowCircleUpRightFill } from "react-icons/pi";
import { LuMicrowave } from "react-icons/lu";

export const amenityIcons = {
  "Free Wi-Fi": <FaWifi />,
  "Wellness Facilities": <FaSpa />,
  "Concierge": <FaBellConcierge />,
  "Daily Housekeeping": <FaBroom />,
  "Entertainment": <FaFilm />,
  "Computer and Internet access": <FaDesktop />,
  "Kids' Clubs": <FaChild />,
  "Free Summit Daily Newspaper": <FaNewspaper />,
  "On-Site Staff Sun-Thurs 9a-5pm, Fri 9am-7pm": <FaUserTie />,
  "Indoor Parking Garage": <FaSquareParking />,
  "Indoor Pool": <FaSwimmer />,
  "Indoor Hot Tub": <FaHotTubPerson />,
  "Indoor Sauna": <FaSpa />,
  "Elevator": <FaElevator />,
  "Welcome Guidebook (online and in room)": <FaBookOpen />,
  "Activities Information Stand": <FaInfoCircle />,
  "Concierge for booking all events and activities.": <FaBellConcierge />,
  "Complimentary beverages-lobby entrance": <FaMugHot />,
  "Ski/Bike Storage Room": <FaSkiing />,
  "SMOKE FREE PROPERTY": <FaSmokingBan />,
  "Apartment-style units": <FaHome />,
  "Fireplaces (wood or gas)": <FaFire />,
  "Microwave": <LuMicrowave />,
  "Dishwasher": <FaBlender />,
  "Coffee maker": <FaCoffee />,
  "Flatscreen TV’s": <FaTv />,
  "Patio or Balcony (some with lake and mountain views)": <FaMountain />,
  "Internet (designated to each room)": <FaWifi />,
  "Fully Equipped Kitchen with dishes, small appliances, and basic cooking equipment.": <FaKitchenSet />,
  "Washer and Dryer (not available in studio)": <FaHandsWash />,
  "Private room phone (required by law)": <FaPhone />,
  "NON-SMOKING ROOMS": <FaSmokingBan />,
};

export const defaultIcon = <PiArrowCircleUpRightFill />;
